import { useCallback, useEffect, useState } from "react";
// @ts-ignore
import Location from "../../models/Location";
// @ts-ignore
import { PromisifyGetModel } from "../../utils/PromisifyRequest";
import { dataToGeoJSON, longLatToGeo } from "./dataToGeoJSON";

const defaultFilter: any | null = null;

type nullStateType = {
  type: string;
  features: any;
};
const nullState: nullStateType = {
  type: "FeatureCollection",
  features: [],
};

const LocationFetch: any = PromisifyGetModel(Location);
export default () => {
  const [data, setData] = useState(nullState);
  const [filter, setFilter] = useState(defaultFilter);

  const getData: () => Promise<void> = useCallback(async (): Promise<void> => {
    if (filter !== null) {
      try {
        const reqBody = { limit: 999, fe_visible: 1 };

        const response: any = await LocationFetch(reqBody);
        const format: {
          type: string;
          crs: { type: string; properties: { name: string } };
          features: any[];
        } = dataToGeoJSON(longLatToGeo)(response.data);

        setData(format);
      } catch (err) {
        console.error("Cannot fetch data from API", err);
      }
    }
  }, [filter]);

  useEffect((): void => {
    getData();
  }, [getData]);

  return [data, setFilter];
};
